import * as types from 'store/modules/login/mutation-types'
import login from 'api/login'
import loginLabels from 'assets/labels/login'
import { router } from 'src/router'
import swal from 'sweetalert'
import configLabels from 'src/../config/label'
import env from 'src/../env.js'

export default {
  state: {
    loginDisp: true,
    forgotPasswordDisp: false,
    forgotPasswordVerifyDisp: false,
    changePasswordDisp: false,
    loadingDisp: false,
    labels: loginLabels,
    response: '',
    lang: configLabels.defaultLang,
    flgAction: '',
    forgotData: '',
    currentUser: {
      p_coduser: '',
      p_codpswd: '',
      p_codempid: '',
      username: {
        en: '',
        th: ''
      },
      p_codpos: '',
      position: {
        en: '',
        th: ''
      },
      p_codcomp: '',
      company: {
        en: '',
        th: ''
      },
      descCodcomp: '',
      descCodpos: '',
      usrcom: [],
      path_image: '',
      googlemaps_api_key: ''
    },
    authStatus: {
      status: false
    },
    baseConn: {},
    forgotPasswordResponse: '',
    changePasswordResponse: '',
    formatPassword: []
  },
  getters: {
    [types.GET_LOGIN_LOADING_DISP] (state) {
      return state.loadingDisp
    },
    [types.GET_LOGIN_LOGIN_DISP] (state) {
      return state.loginDisp
    },
    [types.GET_LOGIN_FORGOT_PASSWORD_DISP] (state) {
      return state.forgotPasswordDisp
    },
    [types.GET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP] (state) {
      return state.forgotPasswordVerifyDisp
    },
    [types.GET_LOGIN_CHANGE_PASSWORD_DISP] (state) {
      return state.changePasswordDisp
    },
    [types.GET_LOGIN_LABELS] (state) {
      return state.labels
    },
    [types.GET_BASE_CONNECTION] (state) {
      return state.baseConn
    },
    [types.GET_RESPONSE] (state) {
      return state.response
    },
    [types.GET_FORGOT_PASSWORD_RESPONSE] (state) {
      return state.forgotPasswordResponse
    },
    [types.GET_LOGIN_FORGOT_PASSWORD_DISP] (state) {
      return state.forgotPasswordDisp
    },
    [types.GET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP] (state) {
      return state.forgotPasswordVerifyDisp
    },
    [types.GET_CHANGE_PASSWORD_RESPONSE] (state) {
      return state.changePasswordResponse
    },
    [types.GET_LANG] (state) {
      return state.lang
    },
    [types.GET_LOGIN_FLG_ACTION] (state) {
      return state.flgAction
    },
    [types.GET_CURRENT_USER] (state) {
      return state.currentUser
    },
    [types.GET_AUTH_STATUS] (state) {
      return state.authStatus
    },
    [types.GET_LOGIN_FORMAT_PASSWORD] (state) {
      return state.formatPassword
    }
  },
  mutations: {
    [types.SET_LOGIN_LOADING_DISP] (state, loadingDisp) {
      state.loadingDisp = loadingDisp
    },
    [types.SET_LOGIN_LOGIN_DISP] (state, loginDisp) {
      state.loginDisp = loginDisp
    },
    [types.SET_LOGIN_FORGOT_PASSWORD_DISP] (state, forgotPasswordDisp) {
      state.forgotPasswordDisp = forgotPasswordDisp
    },
    [types.SET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP] (state, forgotPasswordVerifyDisp) {
      state.forgotPasswordVerifyDisp = forgotPasswordVerifyDisp
    },
    [types.SET_LOGIN_CHANGE_PASSWORD_DISP] (state, changePasswordDisp) {
      state.changePasswordDisp = changePasswordDisp
    },
    [types.SET_BASE_CONNECTION] (state, baseConn) {
      state.baseConn = baseConn
    },
    [types.SET_RESPONSE] (state, response) {
      state.response = response
    },
    [types.SET_FORGOT_PASSWORD_RESPONSE] (state, response) {
      state.forgotPasswordResponse = response
    },
    [types.SET_LOGIN_FORGOT_PASSWORD_DISP] (state, forgotPasswordDisp) {
      state.forgotPasswordDisp = forgotPasswordDisp
    },
    [types.SET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP] (state, forgotPasswordVerifyDisp) {
      state.forgotPasswordVerifyDisp = forgotPasswordVerifyDisp
    },
    [types.SET_CHANGE_PASSWORD_RESPONSE] (state, response) {
      state.changePasswordResponse = response
    },
    [types.SET_LANG] (state, lang) {
      state.lang = lang
      window.localStorage.setItem(env.site + '_lang', lang)
    },
    [types.SET_LOGIN_FLG_ACTION] (state, flgAction) {
      state.flgAction = flgAction
      window.localStorage.setItem('flgAction', flgAction)
    },
    [types.SET_CURRENT_USER] (state, currentUser) {
      state.currentUser = currentUser
      window.localStorage.setItem(env.site + '_currentUser', JSON.stringify(currentUser))
      window.localStorage.setItem(env.site + '_currentUserPermission', '{"edit":["HREL01E","HREL02E","HREL03E","HREL04E","HREL05E","HREL06E"]}')
    },
    [types.SET_AUTH_STATUS] (state, authStatus) {
      state.authStatus = authStatus
      window.localStorage.setItem(env.site + '_authStatus', JSON.stringify(authStatus))
    },
    [types.SET_LOGOUT] (state, currentUser) {
      window.localStorage.setItem(env.site + '_currentUser', JSON.stringify(currentUser))
      window.localStorage.setItem(env.site + '_authStatus', JSON.stringify({ status: false }))
      state.currentUser = currentUser
      state.authStatus = { status: false }
      state.response = ''
      if (navigator.appVersion.indexOf('Trident') !== -1) {
        window.location.reload()
        router.push({ name: 'login' })
      } else {
        router.go({ name: 'login' })
      }
    },
    [types.TOGGLE_LOGIN_PAGE] (state, page) {
      let loginDisp = false
      let forgotPasswordDisp = false
      let forgotPasswordVerifyDisp = false
      let changePasswordDisp = false
      switch (page) {
        case 'login':
          loginDisp = true
          break
        case 'forgotPassword':
          forgotPasswordDisp = true
          break
        case 'forgotPasswordVerify':
          forgotPasswordVerifyDisp = true
          break
        case 'changePassword':
          changePasswordDisp = true
          break
      }
      state.loginDisp = loginDisp
      state.forgotPasswordDisp = forgotPasswordDisp
      state.forgotPasswordVerifyDisp = forgotPasswordVerifyDisp
      state.changePasswordDisp = changePasswordDisp
      state.loadingDisp = false
    },
    [types.SET_FORGOT_DATA] (state, forgotData) {
      state.forgotData = forgotData
    },
    [types.SET_LOGIN_FORMAT_PASSWORD] (state, formatPassword) {
      state.formatPassword = formatPassword
    }
  },
  actions: {
    [types.RECEIVED_BASE_CONNECTION] ({ commit }) {
      login.getBaseConnection()
        .then((response) => {
          const baseConn = JSON.parse(response.request.response)
          commit(types.SET_BASE_CONNECTION, baseConn)
        })
        .catch((response) => {
          commit(types.SET_RESPONSE, 'Cannot Access a Webservice.')
        })
    },
    [types.POST_CURRENT_USER] ({ commit }, formUser) {
      const username = formUser.coduser
      const password = formUser.codpswd
      const codapp = (typeof formUser.codapp === 'undefined' || formUser.codapp === '' ? 'home' : formUser.codapp)
      const autologin = (typeof formUser.autologin === 'undefined' ? 'N' : formUser.autologin)
      commit(types.SET_LOGIN_LOADING_DISP, true)
      if (username !== '' && password !== '') {
        login.postCurrentUser(username, password)
          .then((response) => {
            if (response.request.response) {
              const currentUser = JSON.parse(response.request.response)
              if (currentUser.status !== 1) {
                if (currentUser.message) {
                  if (autologin === 'Y') router.push({ name: 'login' })
                  commit(types.SET_RESPONSE, currentUser.message)
                  commit(types.SET_LOGIN_LOADING_DISP, false)
                }
              } else {
                if (currentUser.flglogin === 'Y') {
                  commit(types.SET_LOGIN_FLG_ACTION, 'login')
                  commit(types.TOGGLE_LOGIN_PAGE, 'changePassword')
                } else {
                  if (currentUser.username) {
                    // currentUser.p_coduser = username
                    if (currentUser.warnPassExpire !== '' && currentUser.warnPassExpire !== null) {
                      swal({
                        title: 'Permit Warning',
                        text: currentUser.warnPassExpire
                      },
                      function () {

                      })
                    }
                    currentUser.p_codpswd = password
                    commit(types.SET_CURRENT_USER, currentUser)
                    commit(types.SET_AUTH_STATUS, { status: true, timestamp: new Date().getTime() })
                    commit(types.SET_RESPONSE, '')
                    if (codapp === 'home') {
                      router.push({ name: codapp })
                    } else {
                      if (router.match(codapp).meta.routeToLaravel) {
                        window.location = window.localStorage.getItem(env.site + '_baseURL') + window.localStorage.getItem(env.site + '_lang') + '/' + codapp
                      } else {
                        window.location = window.localStorage.getItem(env.site + '_baseURL') + codapp
                      }
                    }
                  }
                }
              }
            } else {
              if (autologin === 'Y') router.push({ name: 'login' })
              commit(types.SET_LOGIN_LOADING_DISP, false)
              commit(types.SET_RESPONSE, 'Did not receive a response. Please try again in a few minutes')
            }
          })
          .catch((response) => {
            if (autologin === 'Y') router.push({ name: 'login' })
            commit(types.SET_LOGIN_LOADING_DISP, false)
            commit(types.SET_RESPONSE, 'Cannot Access a Webservice.')
          })
      } else {
        if (autologin === 'Y') router.push({ name: 'login' })
        commit(types.SET_RESPONSE, 'Please enter Username or Password')
        commit(types.SET_LOGIN_LOADING_DISP, false)
      }
    },
    [types.POST_LOGOUT] ({ commit }) {
      login.postGenEmpImage()
      login.postLogout()
        .then((response) => {
          // const result = JSON.parse(response.request.response)
          const currentUser = {
            p_coduser: '',
            p_codpswd: '',
            p_codempid: '',
            username: {
              en: '',
              th: ''
            },
            p_codpos: '',
            position: {
              en: '',
              th: ''
            },
            p_codcomp: '',
            company: {
              en: '',
              th: ''
            },
            descCodcomp: '',
            descCodpos: '',
            usrcom: [],
            path_image: '',
            googlemaps_api_key: ''
          }
          commit(types.SET_LOGOUT, currentUser)
        })
        .catch((response) => {
          // console.log(response)
        })
    },
    [types.POST_FORGOT_PASSWORD] ({ commit }, {params, clearData}) {
      commit(types.SET_LOGIN_LOADING_DISP, true)
      login.postForgotPassword(params)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (data.data.status === 'error') {
            commit(types.SET_RESPONSE, data.data.message)
            commit(types.SET_FORGOT_PASSWORD_RESPONSE, data.data.message)
          } else {
            commit(types.TOGGLE_LOGIN_PAGE, 'forgotPasswordVerify')
            commit(types.SET_FORGOT_DATA, params)
            commit(types.SET_RESPONSE, '')
            clearData()
          }
          commit(types.SET_LOGIN_LOADING_DISP, false)
        })
        .catch((response) => {
          commit(types.SET_LOGIN_LOADING_DISP, false)
          commit(types.SET_RESPONSE, 'ERROR While Process, Please Refresh page then process again.')
        })
    },
    [types.POST_FORGOT_PASSWORD_VERIFY] ({ state, commit }, params) {
      commit(types.SET_LOGIN_LOADING_DISP, true)
      let paramsSend = {
        forg_username: state.forgotData.forg_username,
        forg_otpcode: params.forg_otpcode
      }
      login.postVerifyOtp(paramsSend)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (data.data.status === 'error') {
            commit(types.SET_RESPONSE, data.data.message)
          } else {
            commit(types.TOGGLE_LOGIN_PAGE, 'changePassword')
          }
          commit(types.SET_LOGIN_LOADING_DISP, false)
        })
        .catch((response) => {
          commit(types.SET_LOGIN_LOADING_DISP, false)
          commit(types.SET_RESPONSE, 'ERROR While Process, Please Refresh page then process again.')
        })
    },
    [types.POST_CHANGE_PASSWORD] ({ commit }, params) {
      login.postChangePassword(params)
        .then((response) => {
          const result = JSON.parse(response.request.response)
          if (result.data.status === 'error') {
            commit(types.SET_CHANGE_PASSWORD_RESPONSE, result.data.message)
            commit(types.SET_LOGIN_FORMAT_PASSWORD, [])
          } else if (result.data.status === 'error_format') {
            commit(types.SET_CHANGE_PASSWORD_RESPONSE, result.data.message)
            commit(types.SET_LOGIN_FORMAT_PASSWORD, result.data.fotmat_password)
          } else {
            commit(types.SET_CHANGE_PASSWORD_RESPONSE, result.data.message)
            commit(types.SET_LOGIN_FORMAT_PASSWORD, [])
          }
        })
        .catch((response) => {
          commit(types.SET_CHANGE_PASSWORD_RESPONSE, 'ERROR While Process, Please Refresh page then process again.')
          commit(types.SET_LOGIN_FORMAT_PASSWORD, [])
        })
    },
    [types.POST_AUTH_VUE_MIDDLEWARE] ({ commit, dispatch }, params) {
      let lang = (window.localStorage.getItem(env.site + '_lang')) ? window.localStorage.getItem(env.site + '_lang') : configLabels.defaultLang
      login.postAuthVueMiddleware(params.codapp)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (data.status === 'SUCCESS') {
            params.next()
          } else {
            swal({
              title: 'Error Warning',
              text: configLabels.loginMessageError[lang].ERROR
            },
            function () {
              dispatch(types.POST_LOGOUT)
            })
          }
        })
        .catch((error) => {
          const data = error.response.data
          if (data.status === 'LICENSE') {
            swal({
              title: 'License Warning',
              text: configLabels.loginMessageError[lang].LICENSE
            },
            function () {
              router.push({ name: data.redirect })
            })
          } else if (data.status === 'PERMIT') {
            swal({
              title: 'Permit Warning',
              text: configLabels.loginMessageError[lang].PERMIT
            },
            function () {
              router.push({ name: data.redirect })
            })
          } else if (data.status === 'TIMEOUT') {
            swal({
              title: 'Timeout Warning',
              text: configLabels.loginMessageError[lang].TIMEOUT
            },
            function () {
              dispatch(types.POST_LOGOUT)
            })
          } else if (data.status === 'ERROR') {
            swal({
              title: 'Error Warning',
              text: configLabels.loginMessageError[lang].ERROR
            },
            function () {
              dispatch(types.POST_LOGOUT)
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login/index.js